import api from '@/api'

export default {
  namespaced: true,
  state: {
    feeds: [],
    total: 0,
    fetching: false
  },
  actions: {
    fetchFeeds ({ state, commit, getters }, { type, identifier, options }) {
      commit('fetching', true)

      api.getFeeds(type, identifier, options)
        .then(result => {
          commit('setFetchDataFeeds', { feeds: result.items, total: result.total })
        })
        .catch(() => {
          commit('setFetchDataFeeds', { feeds: [], total: 0 })
          commit('fetching', false)
        })
    },
    async clearFeed ({ state, commit }) {
      commit('setFetchDataFeeds', { feeds: [], total: 0 })
    },
    addFeed ({ state, commit }, { identifier, code }) {
      commit('fetching', true)

      api.getFeed(identifier, code)
        .then(feed => {
          commit('addDataFeed', feed)

          return feed
        })
        .catch(error => {
          commit('fetching', false)

          throw error
        })
    }
  },
  getters: {
    getFeed: state => id => state.feeds.find(feed => feed._id.$oid === id)
  },
  mutations: {
    setFetchDataFeeds (state, { feeds, total }) {
      state.feeds = feeds
      state.total = total
      state.fetching = false
    },
    addDataFeed (state, feed) {
      state.feeds.push(feed)
      state.total = state.feeds.length
      state.fetching = false
    },
    fetching (state, flag) {
      state.fetching = flag
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/feed.js